/**
 * region for libraries*/
 import React, { Component } from "react";
 import PropTypes from "prop-types";
 import { withStyles } from "@material-ui/core/styles";
 import { Toolbar, Typography } from "@material-ui/core";
 import CircularProgress from "@material-ui/core/CircularProgress";
 import Backdrop from "@material-ui/core/Backdrop";
 
 /**  
  * region for redux*/
 import { connect } from "react-redux";
 
 /**
  * region for styles*/
 import { headerCompaniesWithoutKeyContactsStyle } from "./style/headerCompaniesWithoutKeyContactsStyle";
 import { Fragment } from "react";
 
 class HeaderCompaniesWithoutKeyContacts extends Component {
   render() {
     const { classes } = this.props;
     let loadingIsActive = false;
     if (this.props.pending) {
       loadingIsActive = true;
     } else {
       loadingIsActive = false;
     }
     return (
       <Fragment>
         <Toolbar>
           <Typography className={classes.title} component="h1" variant="h6" color="inherit" noWrap>
              FP targets without key contacts
           </Typography>
         </Toolbar>         
         <Backdrop open={loadingIsActive}>
           <CircularProgress color="primary" />
         </Backdrop>
       </Fragment>
     );
   }
 }
 HeaderCompaniesWithoutKeyContacts.propTypes = {
   classes: PropTypes.object.isRequired,
 };
 function mapStateToProps(state) {
   const pending = state.CompaniesWithoutKeyContactsResultReducers.pending;
   return {
     pending,
   };
 }
 
 export default connect(mapStateToProps)(withStyles(headerCompaniesWithoutKeyContactsStyle)(HeaderCompaniesWithoutKeyContacts));
 